import {InitPage} from "../index";
import {ImportFile} from "../common/import_file";

class EpcSettingProfileImport {
    constructor() {
        InitPage("index", () => {
            new ImportFile();
        });

        $('#csv_import_dialog').click(function(e){
            e.preventDefault();
            $('.import-dialog').modal('show');
        });
    }
}

export function LoadPage() {
    InitPage("epc_setting_profiles", () => {
        new EpcSettingProfileImport();
    });
}